<template>
  <div class="Header__warp">
    <div class="Header__logo">
      <a href="/">
        <img  src="../../public/static/header/logo_nstl.png"/>
      </a>
    </div>
    <!-- v-if="userInfo.role > -1 " -->
    <div class="Header__menu" >
      <ul>
        <router-link to="/data_index" v-show="functionInfoList.some(item => item == 'A01')">
          <li :class="{ active: active == HEADER_ACTIVE.INDEX }">数据大屏</li>
        </router-link>
        <router-link to="/data_model" @click.native="inspect('数据建模')"  v-show="functionInfoList.some(item => item == 'B01')"
                     >
          <li :class="{ active: active == HEADER_ACTIVE.DATA_MANAGER }">数据建模</li>
        </router-link>
        <!-- <router-link to="/data_import_List" @click.native="inspect('数据导入')"
                    >
                     v-show="functionInfoList.some(item => item == 'C01')"
          <li :class="{ active: active == HEADER_ACTIVE.DATA_WORK }">数据导入</li>
        </router-link> -->
        <router-link to="/data_view_resource" @click.native="inspect('数据加工')" v-show="functionInfoList.some(item => item == 'C01')"
                    >
          <li :class="{ active: active == HEADER_ACTIVE.DATA_USE ||   active == HEADER_ACTIVE.DATA_WORK}">数据加工</li>
        </router-link>
        <router-link to="/data_mall" @click.native="inspect('数据使用')" v-show="functionInfoList.some(item => item == 'D01')"
                     >
                       <el-dropdown  @command="handleCommand" >
                         <span class="el-dropdown-link">
                              <li :class="{ active: active == HEADER_ACTIVE.DATA_MALL }" style="display:flex;">数据使用</li>
                         </span>
                         <el-dropdown-menu slot="dropdown" class="myModel">
                              <el-dropdown-item command="/data_mall" v-show="functionInfoList.some(item => item == 'D01A01')">
                                   <img src="../assets/menu/myshujumoxing.svg" /> 
                                   数据产品目录
                              </el-dropdown-item>
                               <el-dropdown-item command="/data_statistics" v-show="functionInfoList.some(item => item == 'D01A02')" >
                                   <img src="../assets/menu/myshujusuanfa.svg" />
                                   数据态势统计
                              </el-dropdown-item>
                         </el-dropdown-menu>
                    </el-dropdown>
        </router-link>
        <router-link to="/my_data_model" @click.native="inspect('个人工作台')"  v-show="functionInfoList.some(item => item == 'E01')"
                     >
                     <!-- v-show="functionInfoList.some(item => item == 'F01')" -->
                    <el-dropdown  @command="handleCommand" >
                         <span class="el-dropdown-link">
                              <li :class="{ active: active == HEADER_ACTIVE.MY_DATA }" style="display:flex;">个人工作台</li>
                         </span>
                         <el-dropdown-menu slot="dropdown" class="myModel">
                              <el-dropdown-item command="/my_data_model" v-show="functionInfoList.some(item => item == 'E01A01')">
                                   <img src="../assets/menu/myshujumoxing.svg" /> 
                                   我的数据模型
                              </el-dropdown-item>
                               <el-dropdown-item command="/my_process_task" v-show="functionInfoList.some(item => item == 'E01A02')">
                                     <img src="../assets/menu/renwurenling.svg" />
                                   我的数据加工
                              </el-dropdown-item>
                               <el-dropdown-item command="/data_view_algorithm" v-show="functionInfoList.some(item => item == 'E01A03')" >
                                   <img src="../assets/menu/myshujusuanfa.svg" />
                                   我的数据算法
                              </el-dropdown-item>
                               <el-dropdown-item command="/my_interaction"  v-show="functionInfoList.some(item => item == 'E01A04')">
                                   <img src="../assets/menu/hudongguanli.svg" />
                                   我的互动管理
                              </el-dropdown-item>
                              <el-dropdown-item command="/my_grouping"  v-show="functionInfoList.some(item => item == 'E01A05')"> 
                                   <img src="../assets/menu/wodefenzu.svg" />
                                   我的分组管理
                              </el-dropdown-item>
                              <el-dropdown-item command="/my_data_registration"  v-show="functionInfoList.some(item => item == 'E01A06')"> 
                                   <img src="/static/menu/shujujiazai.svg" />
                                   我的登记产品
                              </el-dropdown-item>
                               <el-dropdown-item command="/AssetsAudit"  v-show="functionInfoList.some(item => item == 'E01A07')">
                                   <img src="../assets/menu/zichanshenhe.svg" /> 
                                   我的产品审核
                              </el-dropdown-item>
                         </el-dropdown-menu>
                    </el-dropdown>
        </router-link>
        <router-link to="/user_power" @click.native="inspect('用户管理')" v-show="functionInfoList.some(item => item == 'F01')"
                     v-if="userInfo.role == '4'"
                     >
          <li :class="{ active: active == HEADER_ACTIVE.USER_MANAGER }">用户管理</li>
        </router-link>
        <router-link to="/about_platform" v-show="functionInfoList.some(item => item == 'G01')">
          <li :class="{ active: active == HEADER_ACTIVE.ABOUT_PLATFORM }">关于平台</li>
        </router-link>
      </ul>
    </div>
     <!-- v-if="userInfo.role > -1" -->
    <div class="Header__user">
      <login-btn :users="userInfo"></login-btn>
    </div>
  </div>
</template>

<script>
import LoginBtn from './LoginBtn.vue'
import {checkUser,getFunctionInfo} from "../util/login";

export default {
  components: {LoginBtn},
  name: 'Header',
  data() {
    return {
      userInfo: {},
      functionInfoList: [],
      ipAddress:"",
      path:'/my_data_model',
    }
  },
  props: {
    active: String
  },
  watch: {
    '$route': function (to, from) {
      //路由跳转时回到顶部
      if (to.name != 'login') {
        this.reloadUser();
      }
    }
  },
  mounted() {
    this.reloadUser();
  },
  methods: {
    reloadUser() {
      this.userInfo = checkUser() || {};
      this.functionInfoList = this.userInfo?.functionInfo || [];
    },
    handleCommand(command){
      this.path = command;
      this.$router.push(command)
    },
    inspect(type) {
      if (type == '数据建模') {
        if (this.functionInfoList.some(item => item == 'B01')) {
          //数据模型设计
          this.$router.push('/data_model');
        }
     //  else if (this.functionInfoList.some(item => item == 'B01A02')) {
     //      //数据模型管理
     //      this.$router.push('/data_model_edit');
     //    } else if (this.functionInfoList.some(item => item == 'B01A03')) {
     //      //知识标签管理
     //      this.$router.push('/knowledge_tabs_list');
     //    } else if (this.functionInfoList.some(item => item == 'B01A04')) {
          //数据算法
     //    }
     //  } else if (type == '数据导入') {
     //    if (this.functionInfoList.some(item => item == 'C01')) {
     //      //信息资源导入
     //    }
     //      this.$router.push('/data_import_List');
     //    } else if (this.functionInfoList.some(item => item == 'C01A02')) {
     //      //信息资源导出
     //      this.$router.push('/data_view_resource');
     //    }
      } else if (type == '数据加工') {
        if (this.functionInfoList.some(item => item == 'C01')) {
          //数据编辑加工
          this.$router.push('/data_view_resource');
           }
     //    } else if (this.functionInfoList.some(item => item == 'D01A02')) {
     //      //知识标签辅助
     //      this.$router.push('/data_calculate');
     //    } else if (this.functionInfoList.some(item => item == 'D01A03')) {
     //      //任务分发
     //      this.$router.push('/task_distribute');
     //    } else if (this.functionInfoList.some(item => item == 'D01A04')) {
     //      //任务认领
     //      this.$router.push('/task_claim');
     //    } else if (this.functionInfoList.some(item => item == 'D01A05')) {
     //      //数据审核
     //      this.$router.push('/task_data_verify');
     //    } else if (this.functionInfoList.some(item => item == 'D01A06')) {
     //      //任务管理
     //      this.$router.push('/processing_task');
     //    }
      } else if (type == '数据使用') {
        if (this.functionInfoList.some(item => item == 'D01')) {
          //数据登记发现
          this.$router.push('/data_mall');
           }
     //    } else if (this.functionInfoList.some(item => item == 'E01A01')) {
     //      //数据产品目录
     //      this.$router.push('/data_mall');
     //    } else if (this.functionInfoList.some(item => item == 'E01A03')) {
     //      //数据内容发现
     //      this.$router.push('/data_get');
     //    } else if (this.functionInfoList.some(item => item == 'E01A04')) {
     //      //数据态势统计
     //      this.$router.push('/data_statistics');
     //    }
      } else if (type == '个人工作台') {
        if (this.functionInfoList.some(item => item == 'E01A01')) {
          //我的数据模型
               this.$router.push('/my_data_model');
         } else if(this.functionInfoList.some(item => item == 'E01A02')){
          //我的数据加工
                this.$router.push('/my_process_task');
         }else if(this.functionInfoList.some(item => item == 'E01A03')){
           //我的数据算法
                this.$router.push('/data_view_algorithm');
         }else if(this.functionInfoList.some(item => item == 'E01A04')){
                this.$router.push('/my_interaction');
         }else if(this.functionInfoList.some(item => item == 'E01A05')){
         
                this.$router.push('/my_grouping');
         }else if(this.functionInfoList.some(item => item == 'E01A06')){
                this.$router.push('/my_data_registration');
         }else if(this.functionInfoList.some(item => item == 'E01A07')){
                this.$router.push('/AssetsAudit');
         }
     //    } else if (this.functionInfoList.some(item => item == 'F01A02')) {
     //      //我的数据加工
     //      this.$router.push('/my_process_task');
     //    } else if (this.functionInfoList.some(item => item == 'F01A03')) {
     //      //我的智能计算
     //      this.$router.push('/my_data_task');
     //    } else if (this.functionInfoList.some(item => item == 'F01A04')) {
     //      //我的数据获取
     //      this.$router.push('/my_data_resource');
     //    } else if (this.functionInfoList.some(item => item == 'F01A05')) {
     //      //我的数据算法
     //      this.$router.push('/my_data_algorithm');
     //    } else if (this.functionInfoList.some(item => item == 'F01A06')) {
     //      //我的互动管理
     //      this.$router.push('/my_interaction');
     //    } else if (this.functionInfoList.some(item => item == 'F01A07')) {
     //      //我的分组管理
     //      this.$router.push('/my_grouping');
     //    } else if(this.functionInfoList.some(item => item == 'F01A08')){
     //       this.$router.push('/data_view_algorithm');
     //    }
      } else if (type == '综合管理') {
        if (this.functionInfoList.some(item => item == 'G01A01')) {
          //用户管理
          this.$router.push('/user_power');
        } else if (this.functionInfoList.some(item => item == 'G01A02')) {
          //数据源管理
          this.$router.push('/data_administrations');
        } else if (this.functionInfoList.some(item => item == 'G01A03')) {
          //权限管理
          this.$router.push('/permissionManagement');
        } else if (this.functionInfoList.some(item => item == 'G01A04')) {
          //安全审计
          this.$router.push('/auditing');
        } else if (this.functionInfoList.some(item => item == 'G01A05')) {
          //工作量统计
          this.$router.push('/workloadStatistics');
        } else if (this.functionInfoList.some(item => item == 'G01A06')) {
          //产品审核
          this.$router.push('/AssetsAudit');
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Header__warp {
  width: 100%;
  height: 68px;
  background: url('../../public/static/header/header_bg_nstl.jpg') no-repeat;
  background-size: cover;
  display: flex;
  position: fixed;
  top: 0px;
  z-index: 1000;
  min-width: 1100px;
}

.Header__logo {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0px 30px;

  img {
    //height: 44px;
    height: 35px;
  }
}

.Header__menu {
  flex: 1;
  display: flex;
  justify-content: flex-end;

  ul {
    display: flex;
    gap: 24px;
    height: 100%;
    a{
     display: flex;
    }
    li {
      font-size: 16px;
      height: 99%;
      color: #c4ebed;
      cursor: pointer;
      display: flex;
      align-items: center;
      position: relative;
      &::after {
        content: ' ';
        position: absolute;
        left: 0px;
        right: 0px;
        height: 4px;
        background: transparent;
        bottom: 0px;
      }

      &:hover {
        color: #3acdc5;
      }

      &:hover a {
        color: #3acdc5;
      }

      &:hover::after {
        background: #3acdc5;
      }
    }

    .active {
      font-size: 18px;
      color: #3acdc5;
    }
    .active::after {
      background: #3acdc5;
    }
  }
}

.Header__user {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0px 30px;
}
.myModel{
     background: #5E9CC8 !important;
     border: solid 0px transparent;
}
.el-dropdown-menu__item{
     display: flex;
     align-items: center;
     color: #fff;
     img{
          width: 20px;
          height: 20px;
          margin-right: 8px;
     }
}
.el-dropdown-menu__item:hover{
     background-color: #2771a8 !important;
     color: #fff !important;
     font-weight: 600 !important;
}
.hovers{
      background-color: #2771a8 !important;
     color: #fff !important;
     font-weight: 600 !important;
}
</style>